const Departments = () => import("Core/configuration/departments/views/Departments");
const DepartmentsForm = () => import("Core/configuration/departments/views/DepartmentsForm");

export default {
    children: [
        {
            path: "configuration/departments",
            name: "departments",
            component: Departments,
            meta: {
                requiresAuth: true,
                title: "lang.departments",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/department/:id?",
            name: "department",
            component: DepartmentsForm,
            meta: {
                requiresAuth: true,
                title: "lang.departments",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
